/**
 * Chrome Web Store extension IDs for the Rovo browser extension, one per
 * environment.
 *
 * Source of truth for the environment → ID mapping is
 * `scripts/generate-env-var-exports.js` (and `build-config/config.js` in the
 * extension-chrome package). Keep these in sync if the published extension IDs
 * ever change.
 */

/** Local development / unpacked build. */
export const ROVO_EXTENSION_ID_DEV = 'dmjofbngkpnmmiccjhikngiodkbofnpc';

/** Staging build. */
export const ROVO_EXTENSION_ID_STAGING = 'deejhllflojhohbeechaicbcofamcbkp';

/** Production build published on the Chrome Web Store. */
export const ROVO_EXTENSION_ID_PROD = 'npbjhobkibekbklkghlhfhieggcggpdb';

/**
 * All known Rovo extension IDs across every environment. Useful when code needs
 * to recognise "is this one of ours?" without caring which environment it is
 * (e.g. Sentry error attribution).
 */
export const ROVO_EXTENSION_IDS: readonly string[] = Object.freeze([
	ROVO_EXTENSION_ID_DEV,
	ROVO_EXTENSION_ID_STAGING,
	ROVO_EXTENSION_ID_PROD,
]);
